import { getEntitiesHistogram } from 'api/entities';
import { errorMessages } from 'constants/errors';
import { asyncActionsNames, reducersNames } from 'constants/reducers';
import { MAP_V2_REDUCER_NAMES } from 'store/slices/mapV2/constants';
import { EntityHistogramResponse } from 'types';

import { buildThunk } from 'utils';

import { TABS_REDUCER_NAMES } from '../../constants';
import { LAYERS_REDUCER_NAMES } from '../constants';

export const getMapEntitiesHistogramThunk = buildThunk<
  EntityHistogramResponse,
  undefined
>(
  `${reducersNames.MAP_V2}/${MAP_V2_REDUCER_NAMES.TABS}/${TABS_REDUCER_NAMES.LAYERS}/${LAYERS_REDUCER_NAMES.STATE}/${asyncActionsNames.GET_MAP_ENTITIES_HISTOGRAM}`,
  errorMessages.GET_MAP_ENTITIES_ERROR,
  getEntitiesHistogram
);
